import {
  LinkedinLogo,
  TwitterLogo,
  InstagramLogo,
  FacebookLogo,
  EnvelopeSimple,
  Phone,
  MapPin,
  GooglePlayLogo,
  AppleLogo } from
"@phosphor-icons/react";
import { useNavigate, useLocation } from "react-router-dom";

const LOGO_URL = "/assets/loado-footer-logo.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const footerLinks = {
    services: [
    { label: "Book Vehicle", href: "#logistics", isSection: true },
    { label: "Shop Materials", href: "#materials", isSection: true },
    { label: "Our Fleet", href: "#vehicles", isSection: true },
    { label: "Live Pricing", href: "#", isSection: true }],

    partners: [
    { label: "Become a Seller", href: "/seller-portal", isSection: false },
    { label: "Join as Driver", href: "/delivery-partner", isSection: false },
    { label: "Partner App", href: "/delivery-partner#app-download", isSection: false }],

    support: [
    { label: "Privacy Policy", href: "/privacy-policy", isSection: false },
    { label: "About Us", href: "/about-us", isSection: false },
    { label: "Career", href: "/career", isSection: false },
    { label: "Refund & Cancellation Policy", href: "/refund-policy", isSection: false },
    { label: "T & C", href: "/terms-conditions", isSection: false },
    { label: "Do's & Don'ts", href: "/dos-donts", isSection: false }],

    legal: [
    { label: "Terms of Service", href: "/support", isSection: false },
    { label: "Privacy Policy", href: "/support", isSection: false },
    { label: "Refund Policy", href: "/support", isSection: false },
    { label: "Cancellation Policy", href: "/support", isSection: false }]

  };

  const socialLinks = [
  { icon: LinkedinLogo, href: "https://linkedin.com/company/loado", label: "LinkedIn" },
  { icon: TwitterLogo, href: "https://twitter.com/loado_in", label: "Twitter" },
  { icon: InstagramLogo, href: "https://instagram.com/loado.in", label: "Instagram" },
  { icon: FacebookLogo, href: "https://facebook.com/loado.in", label: "Facebook" }];


  const handleNavClick = (link) => {
    if (link.isSection) {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          const element = document.querySelector(link.href);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      } else {
        const element = document.querySelector(link.href);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    } else {
      navigate(link.href);
      setTimeout(() => {
        if (link.href.includes("#")) {
          const targetId = link.href.split("#")[1];
          const element = document.getElementById(targetId);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            return;
          }
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 50);
    }
  };

  return (
    <footer
      data-testid="footer"
      className="bg-[#0F172A] text-white">

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-3 lg:col-span-2 space-y-6">
            <img
              src={LOGO_URL}
              alt="Loado"
              className="h-16 w-auto max-w-[240px] object-contain rounded-lg" />

            <p className="text-slate-400 leading-relaxed max-w-sm text-sm">
              Build Faster, Move Smarter. One app for on-demand logistics and instant 
              construction material sourcing.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-2">
              <a
                href="mailto:support@loado.in"
                className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors text-sm">

                <EnvelopeSimple size={16} weight="duotone" />
                support@loado.in
              </a>
              <div className="flex items-center gap-3 text-slate-400 text-sm">
                <MapPin size={16} weight="duotone" />
                Available in Chennai
              </div>
            </div>

            {/* Social Links */}
            <div className="flex gap-3">
              {socialLinks.map((social, index) => <a key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-link-${social.label.toLowerCase()}`}
                className="w-9 h-9 bg-slate-800 hover:bg-[#0055FF] flex items-center justify-center transition-colors"
                aria-label={social.label}>

                  <social.icon size={18} weight="fill" />
                </a>
              )}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm">Services</h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link, index) =>
              <li key={index}>
                  <button
                  onClick={() => handleNavClick(link)}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="text-slate-400 hover:text-white transition-colors text-left text-sm">

                    {link.label}
                  </button>
                </li>
              )}
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm">Partners</h4>
            <ul className="space-y-2">
              {footerLinks.partners.map((link, index) =>
              <li key={index}>
                  <button
                  onClick={() => handleNavClick(link)}
                  className="text-slate-400 hover:text-white transition-colors text-left text-sm">

                    {link.label}
                  </button>
                </li>
              )}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm">Support</h4>
            <ul className="space-y-2">
              {footerLinks.support.map((link, index) =>
              <li key={index}>
                  <button
                  onClick={() => handleNavClick(link)}
                  className="text-slate-400 hover:text-white transition-colors text-left text-sm">

                    {link.label}
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col gap-4">
            {/* Company Info */}
            <div className="text-center">
              <p className="text-slate-400 text-sm font-semibold mb-1">
                Goodskart Logistics & Retail Service Pvt Ltd
              </p>
              <p className="text-slate-500 text-xs">
                NO 19/35 V403 First Floor, Mount Road, Little Mound, Saidapet, Chennai - 600015, Tamil Nadu, India
              </p>
              <p className="text-slate-500 text-xs mt-1">
                CIN: U52292TN2026PTC190744 | Email: <a href="mailto:hello@loado.in" className="text-slate-400 hover:text-white">hello@loado.in</a>
              </p>
            </div>
            {/* Copyright */}
            <div className="flex flex-col md:flex-row justify-between items-center gap-2 pt-4 border-t border-slate-800">
              <p className="text-slate-500 text-xs">
                © {currentYear} Goodskart Logistics & Retail Service Pvt Ltd. All rights reserved.
              </p>
              <p className="text-slate-500 text-xs">
                Last updated: {currentYear}-04-23
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};
